import initialState from './initialState';
import { types } from '../actions/taskTypeActions';

export default function taskTypeReducer(state = initialState.taskTypeReducer, action) {
  switch (action.type) {
    case types.LOAD_TASK_TYPES_SUCCESS:
      return { ...state, taskTypes: action.taskTypes, isLoading: false };
    case types.TASK_TYPES_LOADING_START:
      return { ...state, taskTypes: [], isLoading: true };
    case types.TASK_TYPES_LOADING_STOP:
      return { ...state, isLoading: false };
    case types.CREATE_TASK_TYPE_SUCCESS:
      return { ...state, taskTypes: [...state.taskTypes, action.taskType], isLoading: false };
    case types.UPDATE_TASK_TYPE_SUCCESS:
      return {
        ...state,
        taskTypes: [...state.taskTypes.filter((taskType) => taskType.id !== action.taskType.id), action.taskType],
        isLoading: false,
      };
    case types.DELETE_TASK_TYPE_SUCCESS:
      return {
        ...state,
        taskTypes: state.taskTypes.filter((taskType) => taskType.id !== action.item.id),
        isLoading: false,
      };
    case types.LOADING_TASK_TYPE_ENTITY:
      return { ...state, isLoading: true };
    default:
      return state;
  }
}
